import Columns from '../util/columnConform';
export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {

  var w = 0;

  $( window ).load( function(){

     w = $( window ).width();

  });

  var windowWidth = jQuery(window).innerWidth();

  // expertsArrows();
  // expertsArrowsMobile();
  bioInfoDesktop();
  bioInfoMobile();


  // DESKTOP BIO ARROWS
  let biosArr = [];
  jQuery('.desktop.featured-bios .featured-callout').each(function(){
    biosArr.push(jQuery(this));
  });
  jQuery('.featured-bios.desktop .right-arrow').on('click', function() {
    arrowsRight(biosArr);
    mobileArrowsRight();
  });
  jQuery('.featured-bios.desktop .left-arrow').on('click', function() {
    arrowsLeft(biosArr);
    mobileArrowsLeft();
  });

  // MOBILE BIO ARROWS
  jQuery('.featured-bios.mobile .right-arrow').on('click', function() {
    mobileArrowsRight();
    arrowsRight(biosArr);
  });
  jQuery('.featured-bios.mobile .left-arrow').on('click', function() {
    mobileArrowsLeft();
    arrowsLeft(biosArr);
  });

  doOnOrientationChange();

  setTimeout(function() {
       var columns = new Columns('.desktop .hp-col-set-height:visible', '.desktop .hp-col-match-height:visible');
       var columnsMobile = new Columns('.mobile .hp-col-set-height:visible', '.mobile .hp-col-match-height:visible');

       columnsMobile.equalheight();
       columns.equalheight();
  }, 1500);

  jQuery(window).resize(function() {
      setTimeout(function() {
          var windowWidth = jQuery(window).innerWidth();
          var columns = new Columns('.desktop .hp-col-set-height:visible', '.desktop .hp-col-match-height:visible');
          var columnsMobile = new Columns('.mobile .hp-col-set-height:visible', '.mobile .hp-col-match-height:visible');
          
          columns.equalheight();
          columnsMobile.equalheight();

          if (windowWidth > 991) {
            // expertsArrows();
            jQuery('.desktop .featured-callout').each(function() {
              // jQuery(this).removeClass('off-screen');
            });
          }
          if (windowWidth < 992 && windowWidth > 480) {
            // expertsArrows();
            // jQuery('.featured-callout-3').last().addClass('off-screen');
            // jQuery('.desktop .featured-callout-1').removeClass('off-screen next-bio').addClass('first-bio');
            // jQuery('.desktop .featured-callout-2').removeClass('off-screen first-bio').addClass('next-bio');
            // jQuery('.desktop .featured-callout-3').removeClass('first-bio next-bio').addClass('off-screen');
          }
          if( w != $( window ).width() ){

            if (windowWidth < 481) {
              // expertsArrowsMobile();
              // jQuery('.mobile .mobile-slide-1').removeClass('off-screen').addClass('active');
              // jQuery('.mobile .mobile-slide-2').addClass('off-screen');
              // jQuery('.mobile .mobile-slide-3').addClass('off-screen');
            }

            w = $( window ).width();

            // delete w;
          }

      }, 1500);

  });

  if (windowWidth > 991) {
    jQuery('.desktop .featured-callout').each(function() {
      jQuery(this).removeClass('off-screen');
    });
  }

  if (windowWidth < 992 && windowWidth > 480) {
    // jQuery('.featured-callout').last().addClass('off-screen');
    // jQuery('.desktop .featured-callout-1').removeClass('off-screen').addClass('first-bio');
    // jQuery('.desktop .featured-callout-2').removeClass('off-screen').addClass('next-bio');
    // jQuery('.desktop .featured-callout-3').addClass('off-screen');
  }

  if (windowWidth < 481) {
    // jQuery('.mobile .mobile-slide-1').removeClass('off-screen').addClass('active');
    // jQuery('.mobile .mobile-slide-2').addClass('off-screen');
    // jQuery('.mobile .mobile-slide-3').addClass('off-screen');
  }

  function bioInfoDesktop() {
    $('.desktop .contact .info-btn a').on('click', function() {
      var dataId = $(this).attr('data-id');
      $('.desktop #'+dataId+'').addClass('show-bio');
      $('.desktop #callout-'+dataId+'').addClass('show-bio');

      $('.desktop .bio-arrow').each(function() {
          $(this).fadeOut();
      });

      $('.desktop.featured-bios').addClass('bio-shown');

      $('.desktop .close-btn').on('click', function() {
        $('.desktop.featured-bios').removeClass('bio-shown');

        $('.desktop #callout-'+dataId+'').removeClass('show-bio');
        $('.desktop #'+dataId+'').removeClass('show-bio');
        $('.desktop .bio-arrow').each(function() {
            $(this).fadeIn();
        });
      });
    });
  }

  function bioInfoMobile() {
    $('.mobile .contact .info-btn a').on('click', function() {
      var dataId = $(this).attr('data-id');
      console.log($('.mobile #'+dataId+''));
      $('.mobile .'+dataId+'').addClass('show-bio');
      $('.mobile #callout-'+dataId+'').addClass('show-bio');

      $('.mobile .bio-arrow').each(function() {
          $(this).hide();
      });

      $('.mobile.featured-bios').addClass('bio-shown');

      $('.mobile .close-btn').on('click', function() {
        $('.mobile.featured-bios').removeClass('bio-shown');

        $('.mobile #callout-'+dataId+'').removeClass('show-bio');
        $('.mobile .'+dataId+'').removeClass('show-bio');
        $('.mobile .bio-arrow').each(function() {
            $(this).show();
        });
      });
    });
  }

  function arrowsLeft(biosArr) {
    jQuery.each(biosArr, function() {
      if (jQuery(this).hasClass('off-screen')) {
        jQuery(this).removeClass('off-screen').addClass('first-bio');
      } else if (jQuery(this).hasClass('next-bio')){
        jQuery(this).addClass('off-screen').removeClass('next-bio');
      } else if (jQuery(this).hasClass('first-bio')) {
        jQuery(this).removeClass('first-bio').addClass('next-bio');
      }
    });
  }

  function arrowsRight(biosArr) {
    jQuery.each(biosArr, function() {
      if (jQuery(this).hasClass('off-screen')) {
        // console.log('off-screen');
        jQuery(this).removeClass('off-screen').addClass('next-bio');
      } else if (jQuery(this).hasClass('first-bio')) {
        // console.log('first-bio');
        jQuery(this).addClass('off-screen').removeClass('first-bio');
      } else if (jQuery(this).hasClass('next-bio')) {
        // console.log('next-bio');
        jQuery(this).addClass('first-bio').removeClass('next-bio');
      }
    });
  }

  // function expertsArrows() {
  //   // Array.prototype.move = function (old_index, new_index) {
  //   //     if (new_index >= this.length) {
  //   //         var k = new_index - this.length;
  //   //         while ((k--) + 1) {
  //   //             this.push(undefined);
  //   //         }
  //   //     }
  //   //     this.splice(new_index, 0, this.splice(old_index, 1)[0]);
  //   //     return this; // for testing purposes
  //   // };
  //   let biosArr = [];
  //   jQuery('.desktop.featured-bios .featured-callout').each(function(){
  //     biosArr.push(jQuery(this));
  //   });
  //   jQuery('.desktop .right-arrow').on('click', function() {
  //     // console.log(biosArr[0]);
  //     // console.log(biosArr[1]);
  //     // console.log(biosArr[2]);
  //     // biosArr[0].addClass('off-screen').removeClass('first-bio');
  //     // biosArr[1].addClass('first-bio').removeClass('next-bio');
  //     // biosArr[2].addClass('next-bio').removeClass('off-screen');
  //     // biosArr.move(0,2);
  //     // console.log(biosArr[0]);
  //     // console.log(biosArr[1]);
  //     // console.log(biosArr[2]);

  //     jQuery.each(biosArr, function() {
  //       if (jQuery(this).hasClass('off-screen')) {
  //         console.log('off-screen');
  //         jQuery(this).removeClass('off-screen').addClass('next-bio');
  //       } else if (jQuery(this).hasClass('first-bio')) {
  //         console.log('first-bio');
  //         jQuery(this).addClass('off-screen').removeClass('first-bio');
  //       } else if (jQuery(this).hasClass('next-bio')) {
  //         console.log('next-bio');
  //         jQuery(this).addClass('first-bio').removeClass('next-bio');
  //       }
  //     });
  //     // jQuery('.desktop .featured-callout').first().addClass('off-screen');
  //     // jQuery('.desktop .featured-callout').last().removeClass('off-screen');
  //   });

  //   jQuery('.desktop .left-arrow').on('click', function() {
  //     // console.log(biosArr[0]);
  //     // console.log(biosArr[1]);
  //     // console.log(biosArr[2]);
  //     // biosArr[0].addClass('off-screen').removeClass('first-bio');
  //     // biosArr[1].addClass('first-bio').removeClass('next-bio');
  //     // biosArr[2].addClass('next-bio').removeClass('off-screen');
  //     // biosArr.move(0,2);
  //     // console.log(biosArr[0]);
  //     // console.log(biosArr[1]);
  //     // console.log(biosArr[2]);
  //     // let biosArr = [];
  //     // jQuery('.desktop.featured-bios .featured-callout').each(function(){
  //     //   biosArr.push(jQuery(this));
  //     // });
  //     jQuery.each(biosArr, function() {
  //       if (jQuery(this).hasClass('off-screen')) {
  //         jQuery(this).removeClass('off-screen').addClass('first-bio');
  //       } else if (jQuery(this).hasClass('next-bio')){
  //         jQuery(this).addClass('off-screen').removeClass('next-bio');
  //       } else if (jQuery(this).hasClass('first-bio')) {
  //         jQuery(this).removeClass('first-bio').addClass('next-bio');
  //       }
  //     });
  //   });
  // }

  // function expertsArrowsMobile() {
  //   jQuery('.mobile .right-arrow').on('click', function() {
  //     let $activeBio = jQuery('.mobile .mobile-slide.active');
  //     let $nextBio = $activeBio.next('.mobile .mobile-slide');
  //     console.log($activeBio);
  //     console.log($nextBio);

  //     if ($nextBio.length == 0) {
  //       jQuery('.mobile .mobile-slide-1').removeClass('off-screen').addClass('active');
  //       jQuery('.mobile .mobile-slide-2').addClass('off-screen').removeClass('active');
  //       jQuery('.mobile .mobile-slide-3').addClass('off-screen').removeClass('active');
  //       return;
  //     }

  //     $activeBio.addClass('off-screen').removeClass('active');
  //     $nextBio.removeClass('off-screen').addClass('active');
  //   });

  //   jQuery('.mobile .left-arrow').on('click', function() {
  //     let $activeBio = jQuery('.mobile .mobile-slide.active');
  //     let $prevBio = $activeBio.prev('.mobile .mobile-slide');
  //     console.log($activeBio);
  //     console.log($prevBio);

  //     if ($prevBio.length == 0) {
  //       jQuery('.mobile .mobile-slide-1').addClass('off-screen').removeClass('active');
  //       jQuery('.mobile .mobile-slide-2').addClass('off-screen').removeClass('active');
  //       jQuery('.mobile .mobile-slide-3').removeClass('off-screen').addClass('active');
  //       return;
  //     }

  //     $activeBio.addClass('off-screen').removeClass('active');
  //     $prevBio.removeClass('off-screen').addClass('active');
  //   });
  // }

  function mobileArrowsRight() {
    let $activeBio = jQuery('.mobile .mobile-slide.active');
    let $nextBio = $activeBio.next('.mobile .mobile-slide');
    // console.log($activeBio);
    // console.log($nextBio);

    if ($nextBio.length == 0) {
      jQuery('.mobile .mobile-slide-1').removeClass('off-screen').addClass('active');
      jQuery('.mobile .mobile-slide-2').addClass('off-screen').removeClass('active');
      jQuery('.mobile .mobile-slide-3').addClass('off-screen').removeClass('active');
      return;
    }

    $activeBio.addClass('off-screen').removeClass('active');
    $nextBio.removeClass('off-screen').addClass('active');
  }

  function mobileArrowsLeft() {
    let $activeBio = jQuery('.mobile .mobile-slide.active');
    let $prevBio = $activeBio.prev('.mobile .mobile-slide');
    // console.log($activeBio);
    // console.log($prevBio);

    if ($prevBio.length == 0) {
      jQuery('.mobile .mobile-slide-1').addClass('off-screen').removeClass('active');
      jQuery('.mobile .mobile-slide-2').addClass('off-screen').removeClass('active');
      jQuery('.mobile .mobile-slide-3').removeClass('off-screen').addClass('active');
      return;
    }

    $activeBio.addClass('off-screen').removeClass('active');
    $prevBio.removeClass('off-screen').addClass('active');
  }

  function doOnOrientationChange() {
      // switch(window.orientation) {  
      //     case -90:
      //     case 90:
      //         jQuery('.featured-bios.desktop').removeClass('bio-shown');
      //         jQuery('.featured-bios.desktop .show-bio').removeClass('show-bio');
      //         jQuery('.featured-bios.mobile').removeClass('bio-shown');
      //         jQuery('.featured-bios.mobile .active').removeClass('active');
      //         console.log('landscape');
      //     break; 
      //     default:
      //     // alert('portrait');
      //         console.log('portrait');
      //         jQuery('.featured-bios.mobile').removeClass('bio-shown');
      //         jQuery('.featured-bios.mobile .active').removeClass('active');
      //         jQuery('.featured-bios.desktop').removeClass('bio-shown');
      //         jQuery('.featured-bios.desktop .show-bio').removeClass('show-bio');
      //     break; 
      // }
  }

  $( window ).on( "orientationchange", function( event ) {
    console.log('orientationchange');
    jQuery('.featured-bios.desktop').removeClass('bio-shown');
    jQuery('.featured-bios.desktop .featured-callout').each(function() {
      jQuery(this).removeClass('show-bio');
    });
    jQuery('.featured-bios.mobile').removeClass('bio-shown');
    jQuery('.featured-bios.mobile .featured-callout').each(function(){
      jQuery(this).removeClass('show-bio');
      // console.log(jQuery(this));
    });
    jQuery('.featured-bios.mobile .bio').each(function(){
      jQuery(this).removeClass('show-bio');
      // console.log(jQuery(this));
    });
    jQuery('.desktop .left-arrow').fadeIn();
    jQuery('.desktop .right-arrow').fadeIn();
    jQuery('.mobile .left-arrow').fadeIn();
    jQuery('.mobile .right-arrow').fadeIn();
  });

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/Home.js